import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import action from '../../../../actions/index';
import Locations from './Locations';

const mapStateToProps = state => {
    return {
        locationState: state.locationReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListLocations: (filters) => {
            dispatch(action.getListLocations(filters))
        },
        deleteLocation: (item, filters) => {
            dispatch(action.deleteLocation(item, filters))
        },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Locations));
